export const MINIMAL_ALLOWED_PASSWORD_SCORE = 2
